import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // In case of auth
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authService.logout();
                // maybe need in the future
                // location.reload();
            }

            const error = err.error.message || err.error || err.statusText;
            return throwError(error);
        }));
    }
}
